import { JSX, useCallback, useState } from "react";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ConfirmationDialog from "lib/components/dialog/ConfirmationDialog";
import { asTitle } from "utils/Utils";

export type ActionButtonProps = {
	icon: JSX.Element;
	tooltip: string;
	disabled?: boolean;
	size?: "large" | "medium" | "small";

	dialogTitle: string;
	dialogText: string;
	dialogCancelLabel: string;
	dialogConfirmLabel: string;

	onAction: () => Promise<void>;
};

export default function ActionButton(
	props: Readonly<ActionButtonProps>
): JSX.Element {
	const [showDialog, setShowDialog] = useState(false);

	const openDialog = useCallback((): void => {
		setShowDialog(true);
	}, []);

	const closeDialog = useCallback((): void => {
		setShowDialog(false);
	}, []);

	const onConfirm = useCallback(
		(): Promise<void> => props.onAction().finally(closeDialog),
		[props.onAction, closeDialog]
	);

	return (
		<>
			<Tooltip title={asTitle(props.tooltip)}>
				<span>
					<IconButton
						aria-label={props.tooltip}
						disabled={props.disabled}
						size={props.size}
						onClick={openDialog}>
						{props.icon}
					</IconButton>
				</span>
			</Tooltip>

			{showDialog && (
				<ConfirmationDialog
					title={props.dialogTitle}
					dialogText={props.dialogText}
					cancelLabel={props.dialogCancelLabel}
					confirmLabel={props.dialogConfirmLabel}
					onClose={closeDialog}
					onConfirm={onConfirm}
				/>
			)}
		</>
	);
}
